import { PassengerType, SSROptionsType } from "src/Modules/Flights/constants/JourneyDetails";
import { useJourneyDynamicDetails } from "../../../../../../context";
import SSRChip from "../SSRChip/SSRChip";
import SSRSelectionTable from "../SSRSelectionTable";
import { hasSSR } from "../SSRSelectionTable/utils";

type SSREntryProps = {
  option: SSROptionsType;
  onClick: () => void;
};


export default function SSREntry({ option, onClick }: SSREntryProps) {
  const { passengersState } = useJourneyDynamicDetails();
  const [passengersInput] = passengersState;
  const passengers: PassengerType[] = passengersInput?.passengers ?? [];
  const showTable = hasSSR(passengers, option?.value);
  return (
    <div className="flex flex-col overflow-hidden rounded-md shadow-sm">
      <SSRChip {...option} title={option?.label} hasSelection={showTable} onClick={onClick} />
      {showTable && <SSRSelectionTable type={option?.value} />}
    </div>
  );
}
